export enum TrailerLoadedBy {
  Default = 0,
  ByShipper = 1,
  ByDriver = 4
}

export enum FreightCountedBy {
  Default = 0,
  ByShipper = 1,
  ByDriverOrPallets = 2,
  ByDriverOrPlaces = 4
}

export enum FeeTerms {
  Unknown = 0,
  IsCollect = 1,
  IsPrePaid = 2,
  IsCustomerCheckAcceptable = 3
}

export enum LoadRestrictions {
  Unknown,
  NoTopLoadUnevenLayer,
  NoTopLoadLabeledInstruction,
  LightTopLoadTooHeavy,
  LightTopLoadInadequetePackaging,
  NoRestriction
}

export enum Orientation {
  None = 0,
  AsDefined = 1,
  Turned = 2
}

export enum OrderType {
  Bol = 1,
  NonBol = 2,
  RateShop = 3,
  LogisticPlan = 4,
  Release = 5,
  Osd = 6
}
